export const MCC_LEFT_COLUMN_STYLE = {
  fontWeight: 'bold',
  width: '200px',
  maxWidth: '200px',
  paddingLeft: 0,
};

export const MCC_COLUMNS = [
  {
    id: 'currency',
    label: 'Currency',
    styles: { width: '100px', maxWidth: '100px' },
  },
  {
    id: 'baseRate',
    label: 'Base Rate',
  },
  {
    id: 'markUpRate',
    label: 'Mark-up Rate',
  },
];

export const LP_LEFT_COLUMN_STYLE = {
  fontWeight: 'bold',
  width: '200px',
  maxWidth: '200px',
  paddingLeft: 0,
};

export const LP_COLUMNS = [
  {
    id: 'currency',
    label: 'Currency',
    styles: { width: '200px', maxWidth: '200px' },
  },
  {
    id: 'baseRate',
    label: 'Base Rate',
  },
];
